import { Optional } from 'packages/types'
import { AppConfig } from 'builder/modules/init'
import { UserData } from 'builder/modules/user'

export class FeaturesConfig {
  features: Partial<AppConfig['features']>
  private user: UserData | null

  constructor(features: Optional<AppConfig['features']>, user: UserData | null) {
    this.features = features || {}
    this.user = user
  }

  showResumeDistribution() {
    const premiumUserWithoutRD = this.user?.hasPremiumFeatures && !this.user?.hasPremiumPlusFeatures
    return !!(
      !!this.features?.rdPromo?.rdPromoPlan ||
      (this.features?.resumeDistribution && !premiumUserWithoutRD) ||
      this.user?.scopes?.resumeDistribution
    )
  }

  isUkOrUs() {
    return (
      ['US', 'GB'].includes(this.features.geoipCode || '') ||
      !!this.user?.scopes?.resumeDistribution
    )
  }

  isDashboardV4() {
    return !!this.features.dashboardV4
  }
}
